import Http from './Http';

const prefix = '/website/user';

export const check = data => Http.authApi().post(`${prefix}/check`, data);

export const loginRegister = data => Http.authApi().post(`${prefix}/login`, data);

export const loginToken = data => Http.authApi().post(`${prefix}/login/token`, data);

export const logout = data => Http.authApi().post(`${prefix}/logout`, data);

export const register = data => Http.authApi().post(`${prefix}/register`, data);

export const forgot = data => Http.authApi().post(`${prefix}/password/forgot`, data);

export const getFields = layout_id => Http.authApi().get(`${prefix}/fields/all/${layout_id}`);
